
import { Checkbox } from "@/components/ui/checkbox";

interface RoleCheckboxProps {
  userId: string;
  role: string;
  isChecked: boolean;
  isSaving: boolean;
  onToggle: () => void;
}

export function RoleCheckbox({
  userId,
  role,
  isChecked,
  isSaving,
  onToggle,
}: RoleCheckboxProps) {
  return (
    <div className="flex items-center space-x-2">
      <Checkbox
        id={`${userId}-${role}`}
        checked={isChecked}
        onCheckedChange={onToggle}
        disabled={isSaving}
      />
      <label
        htmlFor={`${userId}-${role}`}
        className="text-sm font-medium capitalize"
      >
        {role}
      </label>
    </div>
  );
}
